import s from './QuizMainContent.less'
import React from 'react'

const QuizCitiesExplanations = () => (
  <div className={s.explanation}>
    <p>Vous souhaitez tester vos connaissances en géographie française ? Ce jeu est fait pour vous !</p>
    <p>
      L’objectif est simple. Il s’agit de positionner correctement des villes sur la carte de France (4 niveaux de
      difficulté).
    </p>
    <h2>Règles du jeu</h2>
    <p>
      Plus la ville demandée est proche de la position cliquée et plus vous avez de points. Positionner une petite ville
      rapporte plus de points qu’une grande ville. Un bonus ★ de 50 points vous est accordé si la ville est positionnée
      à moins de 10 km de son emplacement.
    </p>
  </div>
)

export default QuizCitiesExplanations
